export default __webpack_public_path__ + "static/media/filterone.a9cf6089.svg";